<template>
  <div class="readdraw-module">
    <div class="read-edit" v-if="viewStatus != 2">
      答题组件编辑区域(预览/发布后该区域不显示)
    </div>
    <div class="read-btn" :style="aStyle" @click="onShowTips"></div>
    <AnswerTip
      :img="draw.prizes || defaultPrizes"
      :view="view?.ext_params"
      :moduleId="moduleId"
      v-if="state.isShowDialogAnswerTip"
      :quiz-chance="prizeNum"
      @change-chance="changeChance"
    />
    <AnswerEffect
      :img="draw.prizeAni || defaultAni"
      v-if="state.isShowDialogAnswerEffect"
    />
    <NoNum v-if="state.isShowDialogNoNum" />
    <AnswerError v-if="state.isShowDialogAnswerError" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AnswerTip from './AnswerTip.vue';
import AnswerEffect from './AnswerEffect.vue';
import NoNum from './NoNum.vue';
import AnswerError from './AnswerError.vue';
export default {
  name: 'McAnswer',
  props: {
    draw: {
      type: Object,
      default: () => {}
    },
    view: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => []
    },
    moduleId: {
      type: Number
    },
    viewStatus: {
      type: Number
    }
  },
  data() {
    return {
      defaultFloat:
        '//cdn-tx-admin-test.3kwan.com/2023/07/20/8a05138d185c108d36f389ab1f26f853.gif',
      defaultPrizes:
        '//cdn-tx-admin-test.3kwan.com/2023/07/20/d9446f74597608bebb83ce4f70c1fc6b.png',
      defaultAni:
        '//cdn-tx-admin-test.3kwan.com/2023/07/20/0ec2021663e87d33d4ed0c51c6429370.gif',
      time: null,
      prizeNum: 0
    };
  },
  components: {
    AnswerTip,
    AnswerEffect,
    NoNum,
    AnswerError
  },
  computed: {
    state() {
      return this.$store.state;
    },
    ...mapGetters(['prize']),
    aStyle() {
      return {
        backgroundImage: `url(${this.draw.floatBtn || this.defaultFloat})`
      };
    }
  },
  watch: {
    'view.ext_params.quiz_chance': {
      deep: true,
      immediate: true,
      handler() {
        this.prizeNum = this.view.ext_params.quiz_chance;
      }
    }
  },
  methods: {
    onShowTips() {
      if (this.viewStatus != 2) return;
      this.$store.commit('OPEN_DIALOG', 'AnswerTip');
    },
    changeChance() {
      // 成功后次数减少一次
      this.prizeNum--;
    }
  }
};
</script>

<style lang="scss" scoped>
.read-edit {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.read-btn {
  position: fixed;
  top: 50%;
  right: 10px;
  width: 140px;
  height: 140px;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 500;
  transform: translateY(-50%);
}
</style>
